/* eslint-disable @nx/enforce-module-boundaries */
import {
    IndividualArticleIcon,
    BookMarkPostIcon,
    BookMarkedPostIcon,
  } from '@mybridge/icons';
  import {
    Button,
    Card,
    CardBody,
    HStack,
    Heading,
    MenuItem,
    Box,
    MenuList,
    List,
    ListItem,
    VStack,
    Image,
    Text,
    SimpleGrid,
    Stack,
    CardFooter,
    Container,
    Spinner,
  } from '@mybridge/ui';
  import React, { useRef, useEffect, useState, useContext } from 'react';
  import Link from 'next/link';
  import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
  // import { getMyArticlesFunc } from 'v4/lib/api/blog';
  import EventListItem from 'v4/snippets/events/event-list-item';
  import { useSelector } from 'react-redux';
  import { useRouter } from 'next/router';
  import _ from 'lodash';
  import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@mybridge/ui/tabs';
  import { useDispatch } from 'react-redux';
  // import SectionLoader from 'v4/components/common/loader/sectionLoader';
  import {
    deleteBlog,
    listAllBlogs,
    bookMarkPost,
  } from 'v4/store/slices/blogSlice';
  import { useToast } from '@mybridge/ui';
  import { MatrixProvider } from 'packages/mybridgev4/context/chat-context';
  import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
  import { flattenQueryResults, getNextPageFromURL } from 'v4/utils/utils';
  import { getMyArticlesFunc } from 'v4/store/actions/post.actions';
  import { isMobile } from 'react-device-detect';
  import Head from 'next/head';
  import ArticleListBlock from 'v4/components/articles/articlle-list-block';
import { PublicProfileContext } from '../context';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
  
  const MyPublicArticlesList = () => {
    const {
        publicArticles,
        refetchPublicArticles,
        publicArticlesHasNextPage,
        publicArticlesFetchNextPage,
        publicArticlesIsFetching,
        publicArticlesIsLoading,
        publicArticlesCount
      } = useContext(PublicProfileContext);
      const [showAll, setShowAll] = useState(true);
      const { t } = useTranslator();
      const { pathname } = useRouter();
      useEffect(() => {
        refetchPublicArticles?.();
      }, []);
  
    return (
      <Box>
        {publicArticlesIsLoading ? (
          <Spinner />
        ) : (
          <>
            {publicArticles?.length > 0 ? (
              <ForceSignInWrapper><SimpleGrid columns={[1, 2]} gap={4} spacing={4} p={4} mb={8}>
                {publicArticles?.map((blog) => {
                  return (
                    <Box flex="1" key={blog?.id}>
                      <ArticleListBlock blog={blog} />
                    </Box>
                  );
                })}
              </SimpleGrid></ForceSignInWrapper>
            ) : (
              <VStack w="100%" gap="25px" py="25px" justifyContent="center">
                <Image
                  objectFit="cover"
                  src="/images/defaultArtilcles.svg"
                  alt="No Services"
                />
                <Text fontSize="22px" color="black" textAlign="center">
                  {pathname === '/articles' ? t('notification.whenYouStartCreating') || "When you start creating an article, it will appear here." : "No articles to show"}
                </Text>
                {/* <Link href="/articles/create">Write article</Link> */}
              </VStack>
            )}
          </>
        )}
      </Box>
    );
  };
  
  export default MyPublicArticlesList;
  